// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"458":"c2857419","526":"3b579648","685":"905c94a4","801":"ca7c54f9","962":"ec8b4c79"}[chunkId] + ".chunk.css";
};